import { ChangeEvent, useCallback } from "react";
import { debounce } from "lodash";
import { useTranslation } from "react-migration/lib";
import { SiteOverview } from "react-migration/domains/sites/typings";
import { useUpdateSiteMutation } from "../SaveSiteButton/useUpdateSiteMutation";

export interface EditableSiteDescriptionProps {
  site: Pick<SiteOverview, "_id" | "notes">;
  startedSaving(): void;
  stoppedSaving(): void;
}

export function EditableSiteDescription({
  site: { _id, notes },
  startedSaving,
  stoppedSaving,
}: EditableSiteDescriptionProps) {
  const { t } = useTranslation();
  const [updateSite] = useUpdateSiteMutation();

  const onChangeHandlerDebounced = useCallback(
    debounce(async (e: ChangeEvent<HTMLTextAreaElement>) => {
      startedSaving();
      await updateSite({
        variables: { updateData: { _id, notes: e.target.value } },
        onCompleted: stoppedSaving,
        onError: stoppedSaving,
      });
    }, 250),
    [_id, updateSite]
  );

  return (
    <textarea
      className="atlas-appearance-none atlas-px-3 atlas-py-2 atlas-text-md atlas-w-full atlas-border atlas-border-solid atlas-border-neutral-300 focus:atlas-border-border-action-focus atlas-rounded-md"
      placeholder={t("sites.card.site_card.no_description")}
      onChange={onChangeHandlerDebounced}
      defaultValue={notes}
    />
  );
}
